import i18n from '../../i18n';
import pplIcon from '../images/landing/group.webp';
import teachIcon from '../images/landing/online-counseling.webp';
import classIcon from '../images/landing/classroom.webp';

const LandingCardsData = [
    {
        title: i18n.t('landing_data.cards_0_title'),
        info: i18n.t('landing_data.cards_0_info'),
        desc:[i18n.t('landing_data.cards_0_desc_0'),i18n.t('landing_data.cards_0_desc_1'),i18n.t('landing_data.cards_0_desc_2')],
    },
    {
        title: i18n.t('landing_data.cards_1_title'),
        info: i18n.t('landing_data.cards_1_info'),
        desc:[i18n.t('landing_data.cards_1_desc_0'),i18n.t('landing_data.cards_1_desc_1'),i18n.t('landing_data.cards_1_desc_2')],
    },
    {
        title: i18n.t('landing_data.cards_2_title'),
        info: i18n.t('landing_data.cards_2_info'),
        desc:[i18n.t('landing_data.cards_2_desc_0'),i18n.t('landing_data.cards_2_desc_1'),i18n.t('landing_data.cards_2_desc_2')],
        
    },
    {
        title: i18n.t('landing_data.cards_3_title'),
        info: i18n.t('landing_data.cards_3_info'),
        desc:[i18n.t('landing_data.cards_3_desc_0'),i18n.t('landing_data.cards_3_desc_1'),i18n.t('landing_data.cards_3_desc_2')],
        
    },
    {
        title: i18n.t('landing_data.cards_4_title'),
        info: i18n.t('landing_data.cards_4_info'),
        desc:[i18n.t('landing_data.cards_4_desc_0'),i18n.t('landing_data.cards_4_desc_1'),i18n.t('landing_data.cards_4_desc_2')],
    },
    {
        title: i18n.t('landing_data.cards_5_title'),
        info: i18n.t('landing_data.cards_5_info'),
        desc:[i18n.t('landing_data.cards_5_desc_0'),i18n.t('landing_data.cards_5_desc_1'),i18n.t('landing_data.cards_5_desc_2'),i18n.t('landing_data.cards_5_desc_3')],
    }
];

export default LandingCardsData;
